import styled from "styled-components";
import { StyledHeader, HeaderOverlay, HeaderBorder, GradientText,FlexContainer } from "../styled";
import shinyEffect from "../../assets/images/shinyEffect.png";
import { useEffect ,useState} from "react";

const CustomHeader = styled(StyledHeader)`
    background: linear-gradient(90deg, #635DC2 0%, #9090FB 42%, #635DC2 100%);
    top: -1vh;
`;
const HeaderText = styled(GradientText)`
    font-size: 1.8em;
    font-weight: 700;
    text-transform: capitalize;
`;
const ShinnyImage = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 3;
`;
const ShinnyHeader = (props) =>{
    const [pageName, setPageName] = useState(props?.title);
    useEffect(() => {
        switch (props?.title) {
            case "Home":
                setPageName("Home");
                break;
            case "openPack":
                setPageName("Open Pack");
                break;
            case "publicsale":
                setPageName("Public Sale");
                break;
            default:
                setPageName(props?.title);
    }}, [props?.title])

    return(
        <StyledHeader>
            <ShinnyImage src={shinyEffect} alt="Shinny Effect" />
        <CustomHeader>
            <HeaderBorder style={{ top: 0 }} />
            <HeaderOverlay />
            <FlexContainer>
                <HeaderText>{pageName}</HeaderText>
            </FlexContainer>
        </CustomHeader>
    </StyledHeader>
    )
}

export default ShinnyHeader;
